/*
 * @Author: 🐝
 * @Date: 2023-12-04 16:45:50
 * @LastEditors: Ant🐜
 * @LastEditTime: 2023-12-15 17:06:23
 * @Description: 描述一下
 */
import axios from '../utils/axios'

// 申请分享员
export function setApplySharer(params) {
  return axios.post('/sph/apiSphService/applySharer', params, {
    errorMessageMode: { model: 'toast', option: { type: 'text' } }
  })
}

// 获取分享员申请
export function getSharerApply() {
  return axios.post('/sph/apiSphService/getSharerApply')
}

// 获取分享员分享信息（邀请二维码、背景图等等）
export function getSharerInviteInfo(params) {
  return axios.post('/sph/apiSphService/getSharerInviteInfo', params)
}
